/*
 * Hobby Heaven — Custom JavaScript
 * Created: 2026-03-27
 *
 * Keep this minimal — Horizon handles most interactivity natively.
 * No external libraries. Vanilla JS only.
 * Target: < 10KB
 */

/* Filter dropdown scroll affordance.
 * Horizon hides the scrollbar on the horizontal filter popover
 * (scrollbar-width:none), so a filter with many values scrolls with no cue.
 * We flag the scroller so §9c in hh-custom.css can fade its bottom edge only
 * while there is more content below. Desktop horizontal popover only.
 */
(function () {
  var WRAP = '.facets--horizontal .facets__inputs-wrapper';

  function updateFade(wrap) {
    var overflow = wrap.scrollHeight - wrap.clientHeight > 2;
    wrap.toggleAttribute('data-hh-overflow', overflow);
    var atBottom = wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - 2;
    wrap.toggleAttribute('data-hh-atbottom', atBottom);
  }

  // A filter panel's content is only measurable once its <details> is open.
  // toggle/scroll don't bubble → listen in the capture phase.
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open) return;
      if (!d.classList.contains('facets__panel')) return;
      if (!d.closest('.facets--horizontal')) return;
      var wrap = d.querySelector('.facets__inputs-wrapper');
      if (wrap) requestAnimationFrame(function () { updateFade(wrap); });
    },
    true
  );

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      var wrap = t && t.closest ? t.closest(WRAP) : null;
      if (wrap) updateFade(wrap);
    },
    true
  );
})();

/* Mobile drawer — single-open accordion.
 * Native Horizon allows every <details> to sit open at once (verified: opening a
 * second category left the first open), so all 28 child links can stack into one
 * long scroll. Opening one category now closes the others.
 *
 * Scoped to nav accordions only — the drawer also holds a currency <details> (GBP)
 * which must keep its own behaviour. Scroll position is preserved so collapsing a
 * section ABOVE the tapped row doesn't yank the drawer under the user's finger.
 */
(function () {
  function isNavAccordion(d) {
    return (
      d instanceof HTMLDetailsElement &&
      !!d.querySelector(':scope > summary.menu-drawer__menu-item--mainlist') &&
      !!d.closest('.menu-drawer')
    );
  }

  // `toggle` doesn't bubble → capture phase.
  document.addEventListener(
    'toggle',
    function (e) {
      var opened = e.target;
      if (!isNavAccordion(opened) || !opened.open) return;

      var drawer = opened.closest('.menu-drawer');
      var scroller = drawer && drawer.scrollHeight > drawer.clientHeight ? drawer : null;
      var beforeTop = opened.getBoundingClientRect().top;

      var all = drawer.querySelectorAll('details');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== opened && all[i].open && isNavAccordion(all[i])) all[i].open = false;
      }

      if (scroller) {
        var delta = opened.getBoundingClientRect().top - beforeTop;
        if (delta) scroller.scrollTop += delta;
      }
    },
    true
  );
})();

/* Current-scope highlighting (nav "you are here").
 *
 * Horizon marks only the EXACT current link, never its parent: `_header-menu` uses
 * `link.active` (self-only) and Liquid's `link.child_active` is never read. Measured on
 * /collections/round-bases-1: the top-level "Bases & Trays" carries no active class at
 * all, on desktop OR mobile — the pillar never lights up while you browse inside it.
 *
 * Shopify DOES render one trustworthy marker: header-drawer's `childlink.current` puts
 * aria-current="page" on the matching drawer child. That is server-computed menu
 * ancestry, so we use it as the single source of truth and propagate it UP to the
 * top-level row — no pathname guessing (both menus render the same linklist, in the same
 * order, so index-matching between them is exact).
 *
 * Covers every destination in hh-main-menu. NOT covered: PDPs, which appear in no menu —
 * they'd need template-suffix/tag signals.
 */
(function () {
  // compare only URLs that come from the menu itself — never parse meaning out of the path
  function norm(u) {
    try {
      var a = new URL(u, location.origin);
      return a.pathname.replace(/\/+$/, '') + a.search;
    } catch (e) {
      return '';
    }
  }

  function tops() {
    var drawer = document.querySelector('.menu-drawer');
    return {
      desk: [].slice.call(
        document.querySelectorAll('header-menu .menu-list__list-item:not([slot="overflow"]) > .menu-list__link')
      ),
      draw: drawer ? [].slice.call(drawer.querySelectorAll('.menu-drawer__menu-item--mainlist')) : [],
    };
  }

  function findIndex(t) {
    var i, j, group;

    // 1. menu ancestry — Shopify's own aria-current on the drawer child (most reliable)
    for (i = 0; i < t.draw.length; i++) {
      if (t.draw[i].getAttribute('aria-current') === 'page') return i;
      group = t.draw[i].closest('details');
      if (group && group.querySelector('[aria-current="page"]')) return i;
    }

    // 2. desktop top-level aria-current — set when the current page IS a landing page.
    //    The drawer can't supply this: a parent WITH children renders as <summary>, and
    //    Shopify only marks <a> elements.
    for (j = 0; j < t.desk.length; j++) {
      if (t.desk[j].getAttribute('aria-current') === 'page') return j;
    }

    // 3. exact URL match against the menu's own hrefs. Needed because Shopify does not
    //    mark a link whose URL carries a query string — e.g. New Arrivals
    //    (/collections/all?sort_by=created-descending) never gets aria-current.
    //    Bonus: the dropdown's filtered brush routes match here too.
    var here = norm(location.pathname + location.search);
    for (j = 0; j < t.desk.length; j++) {
      if (norm(t.desk[j].getAttribute('href') || '') === here) return j;
      var li = t.desk[j].closest('.menu-list__list-item');
      var kids = li ? li.querySelectorAll('.menu-list__submenu a[href]') : [];
      for (i = 0; i < kids.length; i++) {
        if (norm(kids[i].getAttribute('href')) === here) return j;
      }
    }
    return -1;
  }

  function apply() {
    var t = tops();
    if (!t.desk.length && !t.draw.length) return;
    var idx = findIndex(t);
    if (idx === -1) return;
    // No "already done" guard: on /pages/bases the desktop menu is present at
    // DOMContentLoaded but the drawer is not, so an early return on the second pass left
    // the drawer permanently unmarked. classList.add is idempotent, so just re-apply.
    if (t.desk[idx]) t.desk[idx].classList.add('is-current-scope');
    if (t.draw[idx]) t.draw[idx].classList.add('is-current-scope');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);

  // Horizon hydrates the drawer AFTER load and replaces its markup, which wipes the class
  // (measured: present at DOMContentLoaded+700ms, gone by load+1000ms — a race we cannot
  // win by timing alone). Re-apply when the drawer opens, i.e. exactly when it is about to
  // be seen, and whenever its subtree is re-rendered.
  document.addEventListener(
    'toggle',
    function (e) {
      if (e.target instanceof HTMLDetailsElement && e.target.querySelector('.menu-drawer')) apply();
    },
    true
  );

  var host = document.querySelector('.header__drawer');
  if (window.MutationObserver && host) {
    new MutationObserver(apply).observe(host, { childList: true, subtree: true });
  }
})();

/* Rating → reviews smooth-scroll.
 * Brushes PDP: the hh-brush-credibility rating is already a server-rendered
 * <a href="#judgeme_product_reviews">. Bases PDP and the default/Essentials PDP:
 * the hero rating is the native review block (blocks/review.liquid — core, not
 * edited), static markup with no link, so we wrap it in the same anchor at
 * runtime. The wrap self-scopes: it needs a #judgeme_product_reviews section on
 * the page AND a hero .rating-wrapper outside it — and the native review block
 * is the ONLY producer of .rating-wrapper in the theme (verified), so this only
 * ever wraps the hero product rating, never the store rating (a plain <span> in
 * hh-pdp-trust-row) or the Judge.me widget's own stars. Brushes has no native
 * review block → no hero .rating-wrapper → no-op there. One delegated handler
 * smooth-scrolls for every template.
 */
(function () {
  'use strict';

  function wrapHeroRating() {
    if (!document.getElementById('judgeme_product_reviews')) return; // PDP with reviews widget only
    var wrappers = document.querySelectorAll('.rating-wrapper');
    var hero = null;
    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].closest('#judgeme_product_reviews')) { hero = wrappers[i]; break; }
    }
    if (!hero || hero.closest('a.hh-rating-link')) return; // none, or already wrapped
    var ratingEl = hero.querySelector('.rating');
    var countEl = hero.querySelector('.rating-count');
    var label = (ratingEl && ratingEl.getAttribute('aria-label')) || 'Customer rating';
    if (countEl) label += ' — ' + countEl.textContent.replace(/\s+/g, ' ').trim();
    var a = document.createElement('a');
    a.href = '#judgeme_product_reviews';
    a.className = 'hh-rating-link';
    a.setAttribute('aria-label', label + '. Jump to reviews.');
    hero.parentNode.insertBefore(a, hero);
    a.appendChild(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapHeroRating);
  } else {
    wrapHeroRating();
  }
  // Horizon can morph the buy zone on variant change — re-wrap if it got reset.
  document.addEventListener('variant:update', function () { setTimeout(wrapHeroRating, 60); });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="#judgeme_product_reviews"]');
    if (!link) return;
    var target = document.getElementById('judgeme_product_reviews');
    if (!target) return; // let the browser handle it if the section is absent
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && history.replaceState) {
      history.replaceState(null, '', '#judgeme_product_reviews');
    }
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();

/* Estimated delivery window — native replacement for the Plex Delivery Estimation
 * app (app-embed). Plex rendered the line correctly but its own bundle
 * (estimation.js) threw an unfixable uncaught TypeError on every PDP. We inject
 * our OWN line into the SAME spot Plex used — inside the native
 * .product-form-buttons, between Add to cart and the dynamic-checkout button —
 * so once the Plex app-embed is turned off, estimation.js stops loading (error
 * gone at source) and this takes its exact place.
 *
 * The date is computed CLIENT-SIDE on purpose: Shopify full-page-caches the HTML,
 * so a server-rendered date could be stale by a day for cached visitors.
 * Rule (confirmed with owner, mirrors Plex): dispatch = same day if ordered before
 * 15:00 on a UK working day, else the next working day; estimated delivery "by" =
 * dispatch + 2 working days, skipping weekends and England-&-Wales bank holidays.
 * All clock reads are in Europe/London via Intl (no library, no local-TZ drift). */
(function () {
  'use strict';

  var CUTOFF_HOUR = 15; // 3pm dispatch cutoff, Mon–Fri
  var WORKING_DAYS_TO_DELIVER = 2; // "by" = dispatch + N working days
  // England & Wales bank holidays, verbatim from gov.uk/bank-holidays.json
  // (england-and-wales division). Covers through 2028-12-26 — extend from the same
  // source when gov.uk publishes 2029 (they list ~2 years ahead). If it lapses the
  // estimate is only ~1 day optimistic on holiday weeks; weekends still handled.
  var HOLIDAYS = {
    '2026-01-01': 1, '2026-04-03': 1, '2026-04-06': 1, '2026-05-04': 1,
    '2026-05-25': 1, '2026-08-31': 1, '2026-12-25': 1, '2026-12-28': 1,
    '2027-01-01': 1, '2027-03-26': 1, '2027-03-29': 1, '2027-05-03': 1,
    '2027-05-31': 1, '2027-08-30': 1, '2027-12-27': 1, '2027-12-28': 1,
    '2028-01-03': 1, '2028-04-14': 1, '2028-04-17': 1, '2028-05-01': 1,
    '2028-05-29': 1, '2028-08-28': 1, '2028-12-25': 1, '2028-12-26': 1
  };

  function londonParts() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    // 'hour' can come back as '24' at midnight in some engines — normalise.
    var h = parseInt(p.hour, 10) % 24;
    return { y: +p.year, m: +p.month, d: +p.day, hour: h };
  }

  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function isWorkingDay(dt) {
    var wd = dt.getUTCDay();
    return wd !== 0 && wd !== 6 && !HOLIDAYS[iso(dt)];
  }
  function addDays(dt, n) { var r = new Date(dt); r.setUTCDate(r.getUTCDate() + n); return r; }
  function nextWorkingDay(dt) { var r = addDays(dt, 1); while (!isWorkingDay(r)) { r = addDays(r, 1); } return r; }
  function addWorkingDays(dt, n) { var r = dt; for (var i = 0; i < n; i++) { r = nextWorkingDay(r); } return r; }

  function estimateLabel() {
    var t = londonParts();
    var today = new Date(Date.UTC(t.y, t.m - 1, t.d));
    var dispatch = (isWorkingDay(today) && t.hour < CUTOFF_HOUR) ? today : nextWorkingDay(today);
    var delivery = addWorkingDays(dispatch, WORKING_DAYS_TO_DELIVER);
    // "Friday, July 24" — US month-day order to match the previous copy exactly.
    var weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' }).format(delivery);
    var month = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long' }).format(delivery);
    return weekday + ', ' + month + ' ' + delivery.getUTCDate();
  }

  var LABEL = null;
  function buildLine() {
    if (!LABEL) { LABEL = estimateLabel(); }
    var p = document.createElement('p');
    p.className = 'hh-delivery-estimate';
    p.setAttribute('data-hh-delivery', '');
    p.innerHTML =
      'Estimated delivery window: by <strong class="hh-delivery-estimate__date">' + LABEL + '</strong>. ' +
      'UK orders ship via Royal Mail Tracked 24. International delivery times vary by destination.';
    return p;
  }

  // The box-level child of `box` that contains `el` (or null). insertBefore/After
  // need a direct child of box as the reference node, but ATC and the dynamic
  // checkout are nested a few levels down, so we climb to their top-level wrapper.
  function topChildOf(box, el) {
    var n = el;
    while (n && n.parentElement && n.parentElement !== box) { n = n.parentElement; }
    return (n && n.parentElement === box) ? n : null;
  }

  function inject() {
    // PDP only: the native product form + its buy-buttons container.
    document.querySelectorAll('product-form-component .product-form-buttons').forEach(function (box) {
      if (box.querySelector('[data-hh-delivery]')) return; // already placed
      var atc = box.querySelector('add-to-cart-component button, .product-form__submit, button[name="add"], button[type="submit"]');
      if (!atc) return; // no Add to cart on this form → don't risk touching the layout
      var line = buildLine();
      // .product-form-buttons is a CSS grid (quantity | Add to cart on a row, Buy
      // with Shop full-width below). Adding a DIRECT child breaks the columns, so —
      // exactly as Plex did — we append INSIDE the Add-to-cart's own grid cell,
      // right after the button. Nested there, the line can't disturb the grid; it
      // just flows below Add to cart, above Buy with Shop.
      var atcCell = topChildOf(box, atc);
      if (atcCell) { atcCell.appendChild(line); }
      else { atc.insertAdjacentElement('afterend', line); }
    });
  }

  function boot() {
    if (!document.querySelector('product-form-component')) return; // not a PDP
    inject();
    // Horizon morphs the buy-buttons on variant change (server HTML has no line) → re-inject.
    document.addEventListener('variant:update', function () { requestAnimationFrame(inject); });
    // Safety net: re-inject if a morph strips it between events.
    var host = document.querySelector('product-form-component');
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        if (!document.querySelector('[data-hh-delivery]')) inject();
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================================
   HH: many-variant dropdown — Essentials PDP only (Session 68)
   Owner: >10 variant pills sprawl the buy column. A buttons-fieldset
   with more than 10 options mounts a mono <select> instead;
   hh-custom.css hides the pills once .hh-variant-select exists (and
   caps the wall at 10 from first paint as the JS-dead fallback).
   The select only drives the NATIVE radio inputs (input.click()), so
   Horizon's variant machinery — price, media, URL, section morphs —
   runs untouched. Morphs can rebuild the fieldset without the select
   (server HTML never has it) → re-mount on variant:update + observer,
   same pattern as the delivery-estimate injector above.
   ============================================================ */
(function () {
  var LIMIT = 10;

  function labelText(lab) {
    var t = lab.querySelector('.variant-option__button-label__text');
    return (t ? t.textContent : lab.textContent).replace(/\s+/g, ' ').trim();
  }

  function mount() {
    document.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fs) {
      var labels = fs.querySelectorAll('label.variant-option__button-label');
      if (labels.length <= LIMIT) return;

      var sel = fs.querySelector('select.hh-variant-select');
      if (!sel) {
        sel = document.createElement('select');
        sel.className = 'hh-variant-select';
        var legend = fs.querySelector('legend');
        sel.setAttribute('aria-label', legend ? legend.textContent.replace(/\s+/g, ' ').trim() : 'Choose option');
        sel.addEventListener('change', function () {
          var labs = fs.querySelectorAll('label.variant-option__button-label');
          var lab = labs[parseInt(sel.value, 10)];
          var input = lab && lab.querySelector('input[type="radio"]');
          if (input && !input.checked) input.click();
        });
        fs.appendChild(sel);
      }

      // (Re)build the options to mirror the current label list + checked state.
      sel.textContent = '';
      labels.forEach(function (lab, i) {
        var input = lab.querySelector('input[type="radio"]');
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = labelText(lab) + (input && input.dataset.optionAvailable === 'false' ? ' — sold out' : '');
        if (input && input.checked) opt.selected = true;
        sel.appendChild(opt);
      });
    });
  }

  function boot() {
    if (!document.querySelector('.hh-pdp-crumbs')) return; // essentials PDP only
    if (!document.querySelector('fieldset.variant-option--buttons')) return;
    mount();
    document.addEventListener('variant:update', function () { requestAnimationFrame(mount); });
    var picker = document.querySelector('variant-picker');
    if (picker && window.MutationObserver) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          if (!picker.querySelector('select.hh-variant-select')) mount();
        });
      }).observe(picker, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================================
   HH: Blueprint variant-aware furniture — Essentials PDP (Session 68)
   Horizon's morph only re-renders the price/buy area on variant
   change; the Blueprint furniture is static server HTML — PROJ in
   both sheet heads, the spec-table rows, the title block and the
   stock LED all kept showing the FIRST variant (measured on
   RCM001–034). `variant:update` ships the full variant in
   e.detail.resource (sku / weight in grams / barcode / available),
   so this just writes the new values in and marks each changed cell
   with a gold background flash (.hh-vflash — CSS in hh-custom.css;
   reduced-motion kills the animation there). Cells that a product
   never rendered (no barcode row, no PROJ segment) are skipped —
   the roster/self-hide logic stays server-side.
   ============================================================ */
(function () {
  function fmtWeight(grams) {
    if (!grams || grams <= 0) return '';
    if (grams >= 1000) {
      var kg = (grams / 1000).toFixed(2).replace(/\.?0+$/, '');
      return kg + ' kg';
    }
    return grams + ' g';
  }

  function flash(el) {
    el.classList.remove('hh-vflash');
    void el.offsetWidth; // restart the animation
    el.classList.add('hh-vflash');
  }

  function setText(el, txt) {
    if (!el || !txt || el.textContent === txt) return;
    el.textContent = txt;
    flash(el);
  }

  function apply(v) {
    if (!v) return;
    if (v.sku) {
      document.querySelectorAll('.hh-hero-sheethead__proj b, .hh-sheet__proj b').forEach(function (b) { setText(b, v.sku); });
      setText(document.querySelector('[data-hh-spec="sku"] .hh-spec__v'), v.sku);
      setText(document.querySelector('[data-hh-tb="sku"]'), v.sku);
    }
    var w = fmtWeight(v.weight);
    if (w) {
      setText(document.querySelector('[data-hh-spec="weight"] .hh-spec__v'), w);
      setText(document.querySelector('[data-hh-tb="weight"]'), w);
    }
    if (v.barcode) {
      setText(document.querySelector('[data-hh-spec="barcode"] .hh-spec__v'), v.barcode);
    }

    // Variant-level dictionary rows (Phase B): the row carries a JSON map of
    // variantId -> value in data-hh-varmap (built by hh-pdp-spec.liquid).
    document.querySelectorAll('[data-hh-varmap]').forEach(function (row) {
      try {
        var map = JSON.parse(row.getAttribute('data-hh-varmap'));
        var val = map[String(v.id)];
        if (val) setText(row.querySelector('.hh-spec__v') || row, val);
      } catch (err) { /* malformed map — leave the server-rendered value */ }
    });

    var stock = document.querySelector('.hh-pdp-stock');
    if (stock) {
      var inStock = !!v.available;
      if (stock.classList.contains('hh-pdp-stock--in') !== inStock) {
        stock.classList.toggle('hh-pdp-stock--in', inStock);
        stock.classList.toggle('hh-pdp-stock--out', !inStock);
        var led = stock.querySelector('.hh-pdp-stock__led');
        stock.textContent = '';
        if (led) stock.appendChild(led);
        stock.appendChild(document.createTextNode(inStock ? 'In stock · same-day dispatch before 3pm' : 'Out of stock'));
        flash(stock);
      }
    }
  }

  if (!document.querySelector('.hh-pdp-crumbs')) return; // essentials PDP only
  document.addEventListener('variant:update', function (e) {
    var v = e.detail && e.detail.resource;
    requestAnimationFrame(function () { apply(v); });
  });
})();
